<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.6562 5H4.34375C3.05141 5 2 6.04673 2 7.33333V16.6667C2 17.9533 3.05141 19 4.34375 19H19.6562C20.9486 19 22 17.9533 22 16.6667V7.33333C22 6.04673 20.9486 5 19.6562 5ZM19.348 6.55556L12.5573 13.4366C12.4114 13.5845 12.2082 13.6693 12 13.6693C11.7918 13.6693 11.5886 13.5845 11.4427 13.4366L4.65207 6.55556H19.348ZM20.4375 16.6667C20.4375 17.0955 20.087 17.4444 19.6562 17.4444H4.34375C3.91297 17.4444 3.5625 17.0955 3.5625 16.6667V7.67108L10.3281 14.5268C10.7659 14.9704 11.3753 15.2249 12 15.2249C12.6247 15.2249 13.2341 14.9704 13.6719 14.5268L20.4375 7.67112V16.6667Z"
      class="fill-current"
    />
  </svg>
</template>
